import {Home} from "./screens/Home";
import {Contact} from "./screens/Contact";
import { Forfait } from "./screens/Forfait";
import { Portfolio } from "./screens/Portfolio";
import { Portrait } from "./screens/Portoflio/Portrait";
import { Paysage } from "./screens/Portoflio/Paysage";
import { Event } from "./screens/Portoflio/Event";
import { Tournage } from "./screens/Portoflio/Tournage";
import { About } from "./screens/About";
import Confidentialite from "./screens/Politique/Confidentialite";

// Composants d'administration
import Login from "./screens/Admin/Login";
import Dashboard from "./screens/Admin/Dashboard";
import ResetPassword from "./screens/Auth/ResetPassword";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";


import {Route, Routes} from "react-router-dom";
import { Footer } from "./components/Footer";
import React from "react";
import Carousel from "./components/Carousel";


const App: React.FC = () => {
  // Déterminer si nous sommes sur une page d'administration
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  return (
   <AuthProvider>
     <div className="flex flex-col min-h-screen">
      {!isAdminRoute && <Carousel />}
      <main className="flex-grow">
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<Home />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Forfait" element={<Forfait />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Event" element={<Event />} />
          <Route path="/Portrait" element={<Portrait />} />
          <Route path="/Paysage" element={<Paysage />} />
          <Route path="/Tournage" element={<Tournage />} />
          <Route path="/politique/confidentialite" element={<Confidentialite />} />
          <Route path="/About" element={<About />} />
          
          {/* Routes d'administration */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
    </div>
   </AuthProvider>
  );
};

export default App;
